"use strict";
import s from "underscore.string";
import _ from "underscore";
import moment from "moment";
import { cleanAmountMatchGroups } from "./general/amountRegex";
export default {
  weight(numberOrString) {
    const num = _.isString(numberOrString) ? parseInt(numberOrString) : numberOrString;
    if (!num) return null;
    return `${s.numberFormat(num)} lbs`;
  },
  currency(value) {
    if (value == null) return void 0;
    if (typeof value === "string" && s.isBlank(value)) return void 0;
    if (typeof value === "number" && isNaN(value)) return void 0;
    const parsed = typeof value === "number" ? value : parseFloat(value);
    const formatted = "$" + s.numberFormat(Math.abs(parsed), 2);
    if (parsed < 0) {
      return "(" + formatted + ")";
    } else {
      return formatted;
    }
  },
  cleanAmount(amount) {
    var _a;
    if (!amount) return null;
    const matchGroups = cleanAmountMatchGroups(amount);
    if (!matchGroups) return null;
    const dollars = (_a = matchGroups.dollars) == null ? void 0 : _a.replace(/\./g, "").replace(/,/g, "");
    const cents = dollars ? matchGroups.centsAfterDollars : matchGroups.centsOnly;
    const toParse = `${matchGroups.sign}${dollars || "0"}.${cents || "00"}`;
    return parseFloat(toParse).toFixed(2);
  },
  date(dateTime) {
    if (_.isEmpty(dateTime)) return "N/A";
    return moment(dateTime).format("ll");
  },
  dateTime(dateTime) {
    return moment(dateTime).format("lll");
  },
  shortDate(dateTime) {
    return moment(dateTime).format("MM/DD/YYYY");
  },
  superShortDate(dateTime) {
    return moment(dateTime).format("M/D/YY");
  },
  shortTime(dateTime) {
    return moment(dateTime).format("hh:mm A");
  },
  superShortTime(dateTime) {
    return moment(dateTime).format("h:mm A");
  },
  longDate(dateTime) {
    return moment(dateTime).format("MMMM Do, YYYY");
  },
  submissionStrategyToString(strategy) {
    if (strategy == "factor_only") {
      return "Factor Only - Documents submitted in the app go directly into TriumphPay Audit";
    } else if (strategy == "portal_only") {
      return "Portal Only - Documents submitted in the app go directly to the Portal";
    }
  }
};
